import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_SOCIAL_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type SharingOnboardingAB = 'a' | 'b' | 'c';

interface SharingOnboardingTariffs {
    trial: string;
    forceTrial: string;
    default: string;
}

export const sharingOnboardingTariffs: SharingOnboardingTariffs = getFeature('sharing-onboarding-tariffs') || {
    trial: 'W64GB_1m_free_paid_account_trial',
    default: 'W64GB_1m_free_paid_account',
    forceTrial: 'W64GB_1m_free_paid_account_force_trial',
};

export const sharingOnboardingAB: SharingOnboardingAB =
    !IS_BIZ_USER && !IS_SOCIAL_USER && !IS_MOBILE_BROWSER && !IS_WEBVIEW && getFeature('sharing-onboarding-ab');

/**
 *  Предполагает выключение фичей
 * 'tabs-folder-sharing-design'
 * 'weblink-list-file-sharing'
 *  из reactApp/appHelpers/featuresHelpers/features/tabsFolderSharingDesign.ts
 */
const isSharingContentOnboardingEnabled = sharingOnboardingAB === 'b';

/**
 *  Предполагает включение фичей
 * 'tabs-folder-sharing-design'
 * 'weblink-list-file-sharing'
 *  из reactApp/appHelpers/featuresHelpers/features/tabsFolderSharingDesign.ts
 */
const isSharingTabOnboardingEnabled = sharingOnboardingAB === 'c';

export const isSharingOnboardingABEnabled = isSharingContentOnboardingEnabled || isSharingTabOnboardingEnabled;

registerExperiment(
    'onboarding',
    sharingOnboardingAB,
    [
        AnalyticEventNames.ENABLE_SHARING_SHOW,
        AnalyticEventNames.SHARING_ADVANCED_SETTINGS_PUBLIC_SHOW,
        AnalyticEventNames.SHARING_ADVANCED_SETTINGS_PUBLIC_HIDDEN,
        AnalyticEventNames.ONBOARDING_TRIAL_BUTTON_SHOW,
        AnalyticEventNames.ONBOARDING_TRIAL_BUTTON_CLICK,
        AnalyticEventNames.ONBOARDING_TOOLTIP_SHOW,
        AnalyticEventNames.ONBOARDING_TOOLTIP_CLOSE,
        AnalyticEventNames.PUBLIC_PASSWORD_SHOW,
        AnalyticEventNames.PUBLIC_PASSWORD_CLICK,
        AnalyticEventNames.ONBOARDING_AUTODELETE_SHOW,
        AnalyticEventNames.ONBOARDING_AUTODELETE_CLICK,
        AnalyticEventNames.SHARING_BRAND_PAGE_SHOW,
        AnalyticEventNames.SHARING_BRAND_PAGE_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ],
    {
        mapEventNames: {
            ONBOARDING_TRIAL_BUTTON_CLICK: 'trial-btn-click',
            ONBOARDING_TRIAL_BUTTON_SHOW: 'trial-btn-show',
            ONBOARDING_AUTODELETE_SHOW: 'autodelete-show',
            ONBOARDING_AUTODELETE_CLICK: 'autodelete-click',
        },
        sendXrayArgs: {
            [AnalyticEventNames.ONBOARDING_TOOLTIP_SHOW]: ({ source }) => ({
                eventName: `${source}-tooltip-show`,
            }),
            [AnalyticEventNames.ONBOARDING_TOOLTIP_CLOSE]: ({ source }) => ({
                eventName: `${source}-tooltip-close`,
            }),
            [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes('advanced_settings') ? 'advst_buy' : eventName,
            }),
            [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes('advanced_settings') ? 'advst_checkout' : eventName,
            }),
        },
    }
);
